import { Key, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export function useQueryParams() {
  const [searchParams, setSearchParams] = useSearchParams();
  const clearParam = useCallback(
    (param: string) => {
      setTimeout(() => {
        setSearchParams((params) => {
          params.delete(param);
          return params;
        });
      });
    },
    [setSearchParams]
  );
  const setParam = useCallback(
    (param: string, value?: string | string[] | Key[]) => {
      const parsedValue = typeof value === "string" ? value : value?.join(",");
      setTimeout(() => {
        setSearchParams((params) => {
          if (parsedValue && parsedValue.length > 0) {
            params.set(param, parsedValue);
          } else {
            params.delete(param);
          }
          return params;
        });
      });
    },
    [setSearchParams]
  );
  return {
    params: Object.fromEntries(searchParams.entries()),
    clearParam,
    setParam,
    setParams: setSearchParams,
    clearParams: () => setSearchParams({}),
  };
}
